<p>admin-prices works!</p>
